import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  container: {
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 1.5),
    margin: theme.spacing(1.5, 0),
    rowGap: theme.spacing(0.5)
  },
  // Cancels the links' vertical padding so they line up with the rule's first line.
  actions: {
    margin: theme.spacing(-0.75, 0)
  },
  edit: {
    marginRight: `-${theme.spacing(1.5)}`
  },
  add: {
    alignSelf: 'flex-start'
  }
})

export default useStyles
